
export { badge } from "/vercel/path0/styled-system/recipes/badge.mjs"